<template>
  <div
    class="heading"
    :data-test="dataTestAttribute + '-heading'"
  >
    {{ label }}
  </div>
  <div :data-test="dataTestAttribute + '-value'">
    <slot />
  </div>
</template>
<script lang="ts" setup>
  defineProps({
    label: { type: String, required: true },
    dataTestAttribute: { type: String, required: false, default: '' }
  });
</script>